(function () {
  'use strict';

  var measurementId = 'G-3MFV62R9VK';
  var formAliases = {
    fa4_VhZ4XhWZtEVZntXI7g: 'support',
    '1btMFhAJAtaVTG96tQfddA': 'dealer',
    Cm42j2JE3v3sryK0k24Fxw: 'product_documents',
  };
  var hubSpotDealerFormId = '1feb761a-da69-4694-b6f5-47208866314e';
  var hubSpotDealerInstances = {};
  var submittedForms = {};
  var privacyApi = null;

  function sendEvent(eventName, parameters) {
    var eventParameters = Object.assign(
      {
        send_to: measurementId,
        transport_type: 'beacon',
      },
      parameters || {}
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
    }
  }

  function updateConsent() {
    if (!privacyApi || typeof window.gtag !== 'function') {
      return;
    }

    var analyticsAllowed = privacyApi.analyticsProcessingAllowed();
    var marketingAllowed = privacyApi.marketingAllowed();
    var preferencesAllowed = privacyApi.preferencesProcessingAllowed();

    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: marketingAllowed ? 'granted' : 'denied',
      ad_user_data: marketingAllowed ? 'granted' : 'denied',
      ad_personalization: marketingAllowed ? 'granted' : 'denied',
      functionality_storage: preferencesAllowed ? 'granted' : 'denied',
      security_storage: 'granted',
    });
  }

  function setCookieBarCookie(section) {
    var days = Number(section.dataset.cookieTime || 365);
    var maxAge = Math.max(1, days) * 24 * 60 * 60;
    document.cookie = 'cookie_bar=1; path=/; max-age=' + maxAge + '; samesite=lax';
  }

  function hasCookieBarCookie() {
    return document.cookie.split(';').some(function (cookie) {
      return cookie.trim().indexOf('cookie_bar=') === 0;
    });
  }

  function showCookieBar(section) {
    if (!hasCookieBarCookie()) {
      section.classList.remove('is-hidden');
    }
  }

  function shouldShowCookieBar() {
    if (!privacyApi) {
      return false;
    }

    return Boolean(
      (typeof privacyApi.shouldShowGDPRBanner === 'function' && privacyApi.shouldShowGDPRBanner()) ||
        (typeof privacyApi.shouldShowCCPABanner === 'function' && privacyApi.shouldShowCCPABanner())
    );
  }

  function setTrackingConsent(preferences) {
    if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') {
      return;
    }

    privacyApi.setTrackingConsent(preferences, function () {
      updateConsent();
    });
  }

  function initializeCookieBar() {
    var section = document.querySelector('.js-cookie-bar');

    if (!section) {
      return;
    }

    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-torva-consent]');

      if (!button) {
        return;
      }

      var accepted = button.dataset.torvaConsent === 'accept';
      setTrackingConsent({
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
        sale_of_data: accepted,
      });
      setCookieBarCookie(section);
      section.remove();
    });

    if (shouldShowCookieBar()) {
      showCookieBar(section);
    }
  }

  function initializePrivacy() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          return;
        }

        privacyApi = window.Shopify.customerPrivacy;
        updateConsent();
        initializeCookieBar();
      }
    );

    document.addEventListener('visitorConsentCollected', function () {
      updateConsent();
    });
  }

  function initializeHulkLeadTracking() {
    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://formbuilder.hulkapps.com') {
        return;
      }

      var message = event.data || {};
      var payload = message.payload || {};
      var formId = String(payload.form_id || '');
      var leadType = formAliases[formId];

      if (message.type !== 'form_submitted' || !leadType) {
        return;
      }

      var completionKey = formId + ':' + String(payload.timestamp || '');

      if (submittedForms[completionKey]) {
        return;
      }

      submittedForms[completionKey] = true;

      var trackedByStory = false;
      if (typeof window.torvaTrackCustomerStoryLeadSuccess === 'function') {
        trackedByStory = window.torvaTrackCustomerStoryLeadSuccess(leadType) === true;
      }

      document.dispatchEvent(
        new CustomEvent('torva:lead:success', {
          detail: { leadType: leadType },
        })
      );

      if (!trackedByStory) {
        sendEvent('generate_lead', {
          lead_type: leadType,
          form_name: leadType,
          page_path: window.location.pathname,
        });
      }
    });
  }

  function getHubSpotEventDetails(event) {
    var detail = event.detail || {};

    return {
      formId: String(detail.formId || ''),
      instanceId: String(detail.instanceId || ''),
    };
  }

  function trackHubSpotDealerSuccess(event) {
    var details = getHubSpotEventDetails(event);

    if (
      details.formId !== hubSpotDealerFormId ||
      !details.instanceId ||
      !hubSpotDealerInstances[details.instanceId]
    ) {
      return;
    }

    var conversionId = '';
    try {
      if (window.HubSpotFormsV4 && typeof window.HubSpotFormsV4.getFormFromEvent === 'function') {
        var form = window.HubSpotFormsV4.getFormFromEvent(event);
        if (form && typeof form.getConversionId === 'function') {
          conversionId = String(form.getConversionId() || '');
        }
      }
    } catch (error) {
      conversionId = '';
    }

    var completionKey = 'hubspot:' + details.formId + ':' + details.instanceId + ':' + conversionId;
    if (submittedForms[completionKey]) {
      return;
    }

    submittedForms[completionKey] = true;

    var trackedByStory = false;
    if (typeof window.torvaTrackCustomerStoryLeadSuccess === 'function') {
      trackedByStory = window.torvaTrackCustomerStoryLeadSuccess('dealer') === true;
    }

    document.dispatchEvent(
      new CustomEvent('torva:lead:success', {
        detail: { leadType: 'dealer' },
      })
    );

    if (!trackedByStory) {
      sendEvent('generate_lead', {
        lead_type: 'dealer',
        form_name: 'TORVA Dealer Application - Website',
        page_path: window.location.pathname,
      });
    }
  }

  function initializeHubSpotDealerLeadTracking() {
    document.addEventListener('hs-form-event:on-ready', function (event) {
      var details = getHubSpotEventDetails(event);

      if (details.formId !== hubSpotDealerFormId || !details.instanceId) {
        return;
      }

      hubSpotDealerInstances[details.instanceId] = true;
    });

    document.addEventListener('hs-form-event:on-submission:success', trackHubSpotDealerSuccess);
  }

  initializePrivacy();
  initializeHulkLeadTracking();
  initializeHubSpotDealerLeadTracking();
})();
